<template>
  <div class="school_teacher">
    <div class="main">
      <!-- 面包屑 -->
      <div class="breadcrumb m">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/school'}">科创培训</el-breadcrumb-item>
          <el-breadcrumb-item>讲师列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 分类 -->
      <div class="m filter_box">
        <type_filter :filterObj="filterObj" :filedType="'id'" @selctedType="selctedType"></type_filter>
        <type_filter :filterObj="filterObj2" @selctedType="selctedType"></type_filter>
      </div>
      <!-- <div class="m sort_box">
        <type_filter :filterObj="filterObj5" @selctedType="selctedType"></type_filter>
      </div>-->
      <!-- 数据总数 -->
      <div class="m list_result">
        <i class="el-icon-search"></i>
        共检索到{{layerpageinfo.total}}条数据
      </div>

      <template v-if="layerpageinfo.total > 0">
        <!-- 列表 -->
        <ul class="m list1">
          <li v-for="item in list" :key="item.id">
            <a href="javascript:;" @click="toDetail(item.id)">
              <div class="list1_l">
                <div class="l">
                  <img v-lazy="item.speaker_headPath" :key="item.speaker_headPath" alt />
                </div>
                <div class="r">
                  <h3>{{item.speaker}}</h3>
                  <h4 v-html="common.filterHtml(item.speaker_synopsis)"></h4>
                  <h4>{{item.technique_type_name}}</h4>
                </div>
              </div>
            </a>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="page_style">
          <myPage :layerpageinfo="layerpageinfo" v-on:pageChange="getData" v-if="list.length" />
        </div>
      </template>
      <!-- 没有数据显示 -->
      <div class="no_date" v-else>
        <img src="@/assets/img/common/no_data.png" alt />
        <p>没有找到相关的讲师哦~</p>
      </div>
    </div>
  </div>
</template>
<script>
import type_filter from "@/components/type_filter/type_filter.vue";
import myPage from "@/components/myPage/myPage.vue";
export default {
  components: {
    type_filter,
    myPage
  },
  data() {
    return {
      searchObj: {},
      layerpageinfo: {
        pageSize: 10,
        pageNo: 0,
        total: 0
      },
      list: [],
      filterObj: {
        name: "技术领域",
        code: "te_technique_type",
        list: [],
        child: {
          //子字典
          name: "",
          selectIndex: -1,
          code: "te_technique_type",
          list: [],
          filedType: "id",
          hideAllbtn: true //隐藏全部按钮
        }
      },
      filterObj2: {
        name: "教育经历",
        code: "te_education_type",
        list: [
          {
            sequence: 6666,
            code: "EducationTypeJuniorCollege",
            name: "专科",
            typeName: "学历",
            typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
            id: "0defb4ba75111121a6b8e600e619955c",
            typeCode: "EducationType"
          },
          {
            sequence: 6666,
            code: "EducationTypeCollege",
            name: "本科",
            typeName: "学历",
            typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
            id: "996548947f2e64626665deb7e6269a9c",
            typeCode: "EducationType"
          },
          {
            sequence: 6666,
            code: "EducationTypeMaster",
            name: "硕士研究生",
            typeName: "学历",
            typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
            id: "25babfa72dafac2fded38775f338d74e",
            typeCode: "EducationType"
          },
          {
            sequence: 6666,
            code: "EducationTypeDoctoral",
            name: "博士研究生",
            typeName: "学历",
            typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
            id: "b6b9ac6bb3b52fcc39ca4a32b8add14a",
            typeCode: "EducationType"
          },
          {
            sequence: "",
            code: "EducationTypeOther",
            name: "其他",
            typeName: "学历",
            typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
            id: "45b19cd861bf6a4191fe2c7b83a7d178",
            typeCode: "EducationType"
          }
        ]
      }
    };
  },
  //路由改变
  beforeRouteUpdate(to, from, next) {
    next();
    //设置name
    this.searchObj.name = to.query.name;
    //获取数据
    this.search();
  },
  mounted() {
    // //查询所有
    this.getData();
    this.initParams();
  },
  methods: {
    //到详情页
    toDetail(id) {
      this.$router.push({
        path: "/teacher_detail",
        query: {
          id: id
        }
      });
    },
    //获取所有类型的字典
    initParams() {
      //TechniqueType
      this.getDictionaries("TechniqueType").then(res => {
        this.filterObj.list = res;
      });
    },
    /**获取对应类型字典
     * @params type 字典类型
     * */
    getDictionaries(type) {
      let obj = {
        typeCode: type,
        pageNo: 0,
        pageSize: 999
      };
      return new Promise(resolve => {
        this.api.getDictionaries(obj).then(res => {
          if (res.error["err_code"] !== 0) return;
          let list = res.obj.list || [];
          resolve(list);
        });
      });
    },
    //条件查询列表
    getData() {
      let params = Object.assign({}, this.searchObj, this.layerpageinfo,{
        type: 'HZCollegeTypeLecturer'
      });
      this.api.getFrontColleges(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.list = list.length ? list : [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    //重置分页数并检索
    search() {
      this.layerpageinfo.pageNo = 0;
      this.getData();
    },
    //筛选点击
    selctedType(obj) {
      //选中的是父类 且 obj.list.code不为空
      if (obj.child && obj.list.code) {
        //等于 技术领域
        if (obj.code === "te_technique_type") {
          //设置子字典选中全部
          this.filterObj.child.selectIndex = -1;
          //获取子字典
          this.getDictionaries(obj.list.code).then(res => {
            this.filterObj.child.list = res;
          });
          this.searchObj[obj.code] = "";
        }
      } else {
        //设置选中的值
        this.searchObj[obj.code] =
          (obj.filedType === "code" ? obj.list.code : obj.list.id) || "";
      }
      //获取列表数据
      this.search();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getData();
    }
  }
};
</script>

<style lang="scss">
.school_teacher {
  background: #f2f1f6;
  .my_header {
    background: #fff;
  }
  .breadcrumb {
    padding: 20px 0;
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #ff733c;
    }
  }
  .filter_box {
    background: #fff;
  }
  .sort_box {
    background: #fff;
    margin-top: 10px !important;
  }
  .list_result {
    height: 53px;
    line-height: 53px;
    font-size: 12px;
    color: #9fa4b1;
    i {
      margin-right: 8px;
    }
  }
  .list1 {
    li {
      position: relative;
      & > a {
        display: flex;
        justify-content: space-between;
        padding: 30px 20px 20px;
        background: #fff;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
        &:hover {
          background: #f6f5f8;
          border-color: #f6f5f8;
        }
        .list1_l {
          display: flex;
          flex: 1;
          .l {
            background: #f0f0f0;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            img {
              width: 80px;
              height: 80px;
              border-radius: 50%;
            }
          }
          .r {
            flex: 1;
            margin-left: 13px;
            h3 {
              font-size: 16px;
              font-weight: bold;
              color: rgba(75, 80, 98, 1);
              .label {
                padding: 0 6px;
                height: 20px;
                border-radius: 12px;
                border: 1px solid #ff733c;
                font-size: 12px;
                line-height: 20px;
                display: inline-block;
                color: #ff733c;
                font-weight: normal;
              }
            }
            h4 {
              font-size: 13px;
              color: #999;
              line-height: 38px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 1000px;
            }
            .lbl_list {
              display: flex;
              .lbl {
                white-space: nowrap;
                padding: 0 5px;
                height: 24px;
                line-height: 24px;
                color: #666;
                background: rgba(240, 240, 240, 1);
                border-radius: 2px;
                font-size: 12px;
                margin-right: 10px;
              }
            }
          }
        }
        .eye {
          width: 100px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          color: #999999;
          i {
            margin-right: 5px;
          }
        }
      }
      &:last-child > a {
        border-bottom: 0;
      }

      .list1_r {
        position: absolute;
        height: 36px;
        right: 20px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        display: flex;
        align-items: center;
        .btn {
          height: 36px;
          line-height: 38px;
          padding: 0 23px;
          border: 1px solid #ff733c;
          font-size: 14px;
          font-weight: 400;
          color: #ff733c;
          border-radius: 2px;
          cursor: pointer;
          &:hover {
            background: #ff733c;
            color: #fff;
          }
        }
        .btn.active {
          background: #ff733c;
          color: #fff;
        }
      }
    }
  }
  .page_style {
    padding: 40px 0;
  }
  .no_date{
    text-align: center;
    padding: 30px 0;
  }
}
</style>
